import {Controller} from '@hotwired/stimulus';

/**
 * Supprime les éléments cochés : envoie leurs valeurs en un seul POST JSON (`{"selectedIds": […]}`) à l'URL en value,
 * puis recharge la page si la réponse est OK. Sans case cochée, rien n'est envoyé ;
 * un second clic pendant l'envoi est ignoré.
 *
 *   <div {{ stimulus_controller('delete-selection', {url: path('…deleteSelection')}) }}>
 *     <input type="checkbox" value="{{ id }}" {{ stimulus_target('delete-selection', 'item') }}> …
 *     <button type="button" {{ stimulus_action('delete-selection', 'delete') }}>Supprimer</button>
 *   </div>
 */
export default class extends Controller {
  static targets = ['item'];
  static values = {url: String};

  #sending = false;

  async delete() {
    const selectedIds = this.itemTargets.filter((item) => item.checked).map((item) => item.value);

    if (selectedIds.length === 0 || this.#sending) {
      return;
    }

    this.#sending = true;

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        body: JSON.stringify({selectedIds}),
        headers: {'Content-Type': 'application/json'},
      });

      if (response.ok) {
        window.location.reload();

        return;
      }
    } catch (error) {
      console.error('Error:', error);
    }

    this.#sending = false;
  }
}
